export function init() {

  //State of button
  stateReexButton();

  confirmReexListener();

};

// Exported
export function inputReexListener(){
  const deliveryTypes = cube.$$('[name="delivery-type"]');

  deliveryTypes.forEach(element => {
    element.addEventListener('change', stateReexButton);
  });

};

// Exported
export function stateReexButton() {
  if(cube.$id('valideReex')) {
    if(cube.$('input[name="delivery-type"]:checked')) {
      cube.$id('valideReex').classList.remove('disabled');
    } else {
      cube.$id('valideReex').classList.add('disabled');
    }
  }
}

function confirmReexListener(){
  const confirmButton = cube.$id('valideReex');

  confirmButton.addEventListener('click', confirmReexDelivery);
};

function confirmReexDelivery(e){

  e.preventDefault();

  if(!cube.$id('valideReex').classList.contains('disabled')) {

    const redirection = e.target.getAttribute('href');

    if(cube.$('input[data-type="pick-up"]:checked') && cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .js-is-picked').checked === true && cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .js-pickup-friend-name').dataset.notMandatory === 'true') {

      const friendName  = cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .js-pickup-friend-name');
      const friendPhone = cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .js-pickup-friend-phone');

      if(friendName.value.trim() === '') {
        friendName.closest('.form-group').classList.add('has-error');
        friendName.nextElementSibling.$('.text').textContent = window.Messages('validationMsg.required');
      }
      if(friendPhone.value === '') {
        friendPhone.closest('.form-group').classList.add('has-error');
        friendPhone.nextElementSibling.$('.text').textContent = window.Messages('validationMsg.phone');
      }
      if(cube.$('input[data-type="pick-up"]:checked') && cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .js-is-picked:checked') && cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .has-error')) {
        cube.$('input[data-type="pick-up"]:checked').closest('.checkout__shipping__wrapper').classList.add('checkout__shipping__wrapper--deployed');
      }
    } else if(cube.$('input[data-type="pick-up"]:checked') && cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .js-is-picked:checked') && cube.$('input[data-type="pick-up"]:checked ~ .checkout__shipping__store .has-error')) {
      cube.$('input[data-type="pick-up"]:checked').closest('.checkout__shipping__wrapper').classList.add('checkout__shipping__wrapper--deployed');
    } else {
      cube.ajax.post('rest/model/atg/commerce/custsvc/returns/ReturnsActor/confirmReturn')
        .onSuccess(() => {
          window.location = redirection;
        })
        .onError()
        .call();
    }
  }

};



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/shipping/shipping-reex.js